<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium m-0">📄 Execution in Cooperative Society</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <!-- <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Block Office<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Financial/Reporting Year<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div> -->
                        <form [formGroup]="targetForm" (ngSubmit)="GetExecution()">
                            <div class="row align-items-end">
                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                  <option value="">--Select--</option>
                  <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                    {{ circle?.sCircleName }}
                  </option>
                </select>
                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                  class="text-danger small">
                  Circle office is required
                </div>
              </div>

                                <!-- Block Office -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="blockOffice">
                                        <option value="" selected>--Select--</option>
                                        <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                            {{ circle?.sBlockName }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                        class="text-danger small">
                                        block Office is required
                                    </div>
                                </div>

                                <!-- Financial Year -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Financial/Reporting Year <span
                                            class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="financialYear">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let years of financialYears" [ngValue]="years">
                                            {{ years?.financialYear }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                        class="text-danger small">
                                        Financial year is required
                                    </div>
                                </div>

                                <!-- Submit -->
                                <div class="col-lg-12 text-end">
                                    <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                        Get Report
                                    </button>
                                </div>

                            </div>
                        </form>
                        <!-- 
                        <div class="col-lg-12 text-end">
                            <button type="button" class="btn btn-primary">Get Report</button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between">
                        <h5 class="font-medium m-0">📄Report</h5>
                        <button type="button" class="btn btn-primary btn-sm"   data-bs-toggle="modal"
                                                data-bs-target="#ConsumerGoodsDistributionDataModal" (click)="addData()"  *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">+ Add Execution Cases, {{currentMonth?.name}}</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                     <table class="table table-bordered table-hover">
  <thead>
    <tr class="texture font-size-12">
      <th rowspan="2" style="text-align: center; width: 2%">S. N.</th>
      <th rowspan="2" style="width: 10%">Month</th>
      <th class="text-center" colspan="2">Overdue at the beginning of month</th>
      <th class="text-center" colspan="2">Cases Referred during the Month</th>
      <th class="text-center" colspan="2">Cases Decided during the Month</th>
      <th class="text-center" colspan="2">Balance at the end of the month</th>
      <th rowspan="2" class="text-center" style="width:7%">Action</th>
    </tr>
    <tr class="texture font-size-12">
      <th class="text-right">No.</th>
      <th class="text-right">Amt. (<i class="fa fa-inr fa-mr-0"></i>)</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt. (<i class="fa fa-inr fa-mr-0"></i>)</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt. (<i class="fa fa-inr fa-mr-0"></i>)</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt. (<i class="fa fa-inr fa-mr-0"></i>)</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let row of casesData; let i = index">
      <td class="text-center">{{ i + 1 }}.</td>
      <td>{{ getMonthName(row.dataMonth) }}, {{ getYearFromFinancialYear(row.financialYear, row.dataMonth) }}</td>

      <td class="text-right">{{ row.overDueBeginingNo ?? 0 }}</td>
      <td class="text-right">{{ row.overDueBeginingAmt ?? 0 | number: '1.2-2' }}</td>

      <td class="text-right">{{ row.casesRefNo ?? 0 }}</td>
      <td class="text-right">{{ row.casesRefAmt ?? 0 | number: '1.2-2' }}</td>

      <td class="text-right">{{ row.casesDecidedNo ?? 0 }}</td>
      <td class="text-right">{{ row.casesDecidedAmt ?? 0 | number: '1.2-2' }}</td>
<td class="text-right">
  {{ ((row.balanceAtEndNo ?? 0) + (row.casesRefNo ?? 0) - (row.casesDecidedNo ?? 0)) }}
</td>

      <!-- <td class="text-right">{{ (row.balanceAtEndNo + row.casesRefNo - row.casesDecidedNo  ?? 0 ) }}</td> -->
      <!-- <td class="text-right">{{ (row.overDueBeginingAmt + row.casesRefAmt - row.casesDecidedAmt  ?? 0 )}}</td> -->
       <td class="text-right">{{ ((row.overDueBeginingAmt ?? 0) + (row.casesRefAmt ?? 0) - (row.casesDecidedAmt ?? 0)) }}</td>


      <td class="text-center no-wrap">
        <ng-container *ngIf="!row.isVerified && ( this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13 ); else verifiedBlock">
         <button type="button" class="btn btn-primary btn-sm" title="Click to Edit"
               (click)="editRow(row)">
              <i class="bi bi-pencil-square"></i>
            </button>
              <button type="button" class="btn btn-success btn-sm" title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
               data-bs-toggle="modal" data-bs-target="#verifyConfirmModal" (click)="setDeleteIndex(row?.id)">
              <i class="bi bi-clipboard2-check"></i>
            </button>
            <button type="button" class="btn btn-danger btn-sm" title="Click to Delete" 
               data-bs-toggle="modal" data-bs-target="#deleteConfirmModal"
                                                (click)="setDeleteIndex(row?.id)">
              <i class="bi bi-trash3"></i>
            </button>
          
        </ng-container>
        <ng-template #verifiedBlock>
          <button type="button" class="btn btn-primary btn-sm" title="Verified">
            <i class="bi bi-lock"></i>
          </button>
        </ng-template>
      </td>
    </tr>
  </tbody>
</table>
  <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete this?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="DeleteExecutionData(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
 <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="verifyExecutionData(deleteIndex)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Modal -->
                <div class="modal fade" id="ConsumerGoodsDistributionDataModal" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1" aria-labelledby="ConsumerGoodsDistributionDataModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="ConsumerGoodsDistributionDataModalLabel">Add Execeution Cases Data</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">

<form [formGroup]="ElecetionCasesForm">
  <div class="row">
    <!-- Financial Year -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Financial/Reporting Year <span
                                            class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="financialYear">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let years of financialYears" [ngValue]="years">
                                            {{ years?.financialYear }}
                                        </option>
                                    </select>
                                    <div *ngIf="ElecetionCasesForm.get('financialYear')?.touched && ElecetionCasesForm.get('financialYear')?.invalid"
                                        class="text-danger small">
                                        Financial year is required
                                    </div>
                                </div>
  

          <!-- Block Office -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="blockOffice">
                                        <option value="" selected>--Select--</option>
                                        <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                            {{ circle?.sBlockName }}
                                        </option>
                                    </select>
                                    <div *ngIf="ElecetionCasesForm.get('blockOffice')?.touched && ElecetionCasesForm.get('blockOffice')?.invalid"
                                        class="text-danger small">
                                        block Office is required
                                    </div>
                                </div>

                            
                                  <!-- During Month -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">During Month <span
                                                    class="text-danger">*</span></label>
                                            <!-- <input class="form-control" type="month" formControlName="duringMonth" placeholder="e.g., May 2025" /> -->
                                            <select class="form-control" formControlName="dataMonth">
                                                <option value="" selected>--Select Month--</option>
                                                <option *ngFor="let month of months" [value]="month?.iMonthId">
                                                    {{ month?.sMonthName }}
                                                </option>
                                            </select>

                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="ElecetionCasesForm.get('dataMonth')?.touched && ElecetionCasesForm.get('dataMonth')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>
                                        </div>


      <!-- Cases as on Start -->
      <div class="col-lg-4 col-md-6 mb-2">
        <label class="form-label">Cases as on 01 {{ currentMonth?.name }}</label>
        <input type="number" min="0" step="1" class="form-control" formControlName="overDue" />
        <div class="text-danger small" *ngIf="ElecetionCasesForm.get('overDue')?.touched && ElecetionCasesForm.get('overDue')?.invalid" style="min-height: 1.25rem;"> Enter Valid Number</div>
      </div>

      <!-- Fresh Cases -->
      <div class="col-lg-4 col-md-6 mb-2">
        <label class="form-label">No. of Cases reffered during  {{ currentMonth?.name }}</label>
        <input type="number" class="form-control" min="0" step="1" formControlName="reffredCases" />
        <div class="text-danger small" *ngIf="ElecetionCasesForm.get('reffredCases')?.touched && ElecetionCasesForm.get('reffredCases')?.invalid" 
         style="min-height: 1.25rem;">Enter Valid Number</div>
      </div>

      <!-- Decided Cases -->
      <div class="col-lg-4 col-md-6 mb-2">
        <label class="form-label">No. of Cases Decided on  {{ currentMonth?.name }}</label>
        <input type="number" class="form-control" min="0" step="1" formControlName="decidedCases" />
        <div class="text-danger small" style="min-height: 1.25rem;" *ngIf="ElecetionCasesForm.get('decidedCases')?.touched && ElecetionCasesForm.get('decidedCases')?.invalid" >Enter Valid Number</div>
      </div>

      <!-- Amount as on Start -->
      <div class="col-lg-4 col-md-6 mb-2">
        <label class="form-label">Amount corresponding to Cases as on  {{ currentMonth?.name }}</label>
        <input type="number" class="form-control" min="0" step="1" formControlName="amountAsOnStart" />
        <div class="text-danger small" style="min-height: 1.25rem;" *ngIf="ElecetionCasesForm.get('amountAsOnStart')?.touched && ElecetionCasesForm.get('amountAsOnStart')?.invalid" >Enter Valid Amount</div>
      </div>

      <!-- Amount for Fresh Cases -->
      <div class="col-lg-4 col-md-6 mb-2">
        <label class="form-label">Amount cooresponding to Reffered during {{ currentMonth?.name }}</label>
        <div class="input-group">
          <span class="input-group-text">₹</span>
          <input type="number" class="form-control" min="0" step="1" formControlName="reffredCasesAmount" />
          <span class="input-group-text">.00</span>
        </div>
        <div class="text-danger small" style="min-height: 1.25rem;" *ngIf="ElecetionCasesForm.get('reffredCasesAmount')?.touched && ElecetionCasesForm.get('reffredCasesAmount')?.invalid" >Enter Valid Amount</div>
      </div>

      <!-- Amount for Decided Cases -->
      <div class="col-lg-4 col-md-6 mb-2">
        <label class="form-label">Amount Corresponding to the cases Decided during {{ currentMonth?.name }}</label>
        <div class="input-group">
          <span class="input-group-text">₹</span>
          <input type="number" class="form-control" min="0" step="1" formControlName="decidedCasesAmount" />
          <span class="input-group-text">.00</span>
        </div>
        <div class="text-danger small" style="min-height: 1.25rem;" *ngIf="ElecetionCasesForm.get('decidedCasesAmount')?.touched && ElecetionCasesForm.get('decidedCasesAmount')?.invalid" >Enter Valid Amount</div>
      </div>

  </div>
</form>


                                <!-- <div class="row">

                                    <div class="col-lg-4 col-md-6 mb-2">
                                        <label class="form-label">Financial/Reporting Year<sup
                                                class="text-danger">*</sup></label>
                                        <input type="text" class="form-control" value="2025-26" disabled  />
                                    </div>

                                    <div class="col-lg-4 col-md-6 mb-2">
                                        <label class="form-label">Block Office<sup class="text-danger">*</sup></label>
                                        <input type="text" class="form-control" value="Mashobra - Block Office"
                                            disabled />
                                    </div>

                                    <div class="col-lg-4 col-md-6 mb-2">
                                        <label class="form-label">Data For Month<sup class="text-danger">*</sup></label>
                                        <input type="text" class="form-control" value="August, 2025" disabled />
                                    </div>

                                    <div class="col-lg-12">
                                        <div class="table-responsive">
                                            <table class="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Distribution Location</th>
                                                        <th>Controlled (₹ in lacs)</th>
                                                        <th>Non-Controlled (₹ in lacs)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>Urban</td>
                                                        <td>
                                                            <div class="input-group">
                                                                <span class="input-group-text">₹</span>
                                                                <input type="text" class="form-control"
                                                                    placeholder="Please Fill the Data" />
                                                                <span class="input-group-text">lacs</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-group">
                                                                <span class="input-group-text">₹</span>
                                                                <input type="text" class="form-control"
                                                                    placeholder="Please Fill the Data" />
                                                                <span class="input-group-text">lacs</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>Rural</td>
                                                        <td>
                                                            <div class="input-group">
                                                                <span class="input-group-text">₹</span>
                                                                <input type="text" class="form-control"
                                                                    placeholder="Please Fill the Data" />
                                                                <span class="input-group-text">lacs</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-group">
                                                                <span class="input-group-text">₹</span>
                                                                <input type="text" class="form-control"
                                                                    placeholder="Please Fill the Data" />
                                                                <span class="input-group-text">lacs</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>







                                </div> -->

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModel()">Close</button>
                                <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>

    </div>
</div>